import { LOCALES, KEYS } from '../constants';

const plPLTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_POLISH_PL] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"Rola partnera",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Integrator",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Dostawca",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"Poziom partnera",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"Specjalizacja partnera",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:" Usługa Cisco Powered",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"Nazwa Partnera",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Lokalizacja",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"Kraj",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"Słowo kluczowe dla nazwy partnera",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"Słowo kluczowe dla nazwy partnera",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Sortowanie",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Specjalizacje",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"Specjalizacje Partnera",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Poziom dostawcy i usługi Cisco",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"złoty dostawca",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"główny dostawca",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"wybierz dostawcę",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Zdobądź informacje",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Poproś o ofertę",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"Otwórz",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Rozwiń",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Zwiń",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Wybierz kraj/region",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Wybierz stanowisko",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Wybierz specjalizacje",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Wybierz usługi Cisco",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Wybierz kompetencję(-e)",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Wybierz poziom(y)",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"Kraj/region partnera",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Poziomy integratora",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Poziomy dostawcy",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Specjalizacje integratora",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Usługi Cisco",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"Nazwy partnerów",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Wstecz",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"Wszystkie wyniki",
    [KEYS.L18N_KEY_LABEL_ALL ]:"Wszystkie",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Zapisano",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"Moi partnerzy",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Dodaj",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Usuń",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Dodaj do porównania ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"Wybierz co najmniej jeszcze jeden",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"Porównaj wybranych ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Usuń z porównywarki",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"Porównaj",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"Poziom partnera",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"Trwa przetwarzanie",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"wynik",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"wyników",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"Brak wyników",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"wynik w",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"wyniki w",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"Brak wyników w",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Poprzednie",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Poprzednie",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Następne",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Zapisz",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Wiedza",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Informacje ogólne",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"to element firmy Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Integratorzy tworzą kompleksowe rozwiązania dla naszych klientów. Przede wszystkim dokonują transakcji odsprzedaży, ale wykorzystują także własną, unikatową wiedzę, aby rozwiązywać problemy biznesowe klientów",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"Dostawcy są ekspertami w dostarczaniu rozwiązań zarządzanych i chmurowych. Klienci oczekują większej elastyczności w zakresie korzystania z rozwiązań, a rola dostawców na rynku staje się coraz ważniejsza.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Poprzednie wyszukiwania",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Poprzednie wyszukiwanie",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Role ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Technologia",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Branże",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Integratorzy",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Dostawcy",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Inne",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Inne",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"Nie zapisano żadnych innych partnerów",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"Brak zapisanych integratorów",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"Brak zapisanych dostawców",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"filtruj według potrzeby",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"szukaj według połączonych kryteriów",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"szukaj według lokalizacji",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"Na całym świecie obsługuje 1 partner",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"Na całym świecie",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"istnieją partnerzy obsługujący",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"Nie ma partnerów obsługujących",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"Istnieje 1 partner obsługujący w",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"partnerzy obsługujący w",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"Nie ma partnerów obsługujących w",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Zmiana lokalizacji",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"Filtruj według potrzeb",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Wyszukaj",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"według nazwy, poziomu i wiedzy eksperckiej",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"wybrane",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"Brak dopasowań",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"Uszereguj w górę",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"Uszereguj w dół",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"Nazwa/imię i nazwisko rosnąco",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"Nazwa/imię i nazwisko malejąco",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"Wymagany login",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"Aby wykonać to działanie, należy się zalogować",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Przywracanie wyszukiwania nie powiodło się",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Zaloguj",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"Pomyślnie zapisano partnera",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"Nie można zapisać partnera",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"Pomyślnie usunięto partnera",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"Nie można usunąć partnera",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Wpisz słowo kluczowe, aby wyszukać według nazwy/imienia i nazwiska, poziomu lub kompetencji",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Programiści to eksperci, którzy tworzą oprogramowanie i rozwiązania sprzętowe dostosowane do technologii Cisco, dzięki czemu powstają unikatowe rozwiązania łączące systemy w celu osiągania oczekiwanych rezultatów.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"Doradcy to eksperci ze szczegółową wiedzą branżową, którzy pomagają firmom w rozwiązywaniu złożonych problemów biznesowych.",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Zróżnicowany partner",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"Alfabetycznie",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"Najwięcej wiedzy specjalistycznej",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Programista",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Doradca",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filtry",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filtruj",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Kompetencje partnera",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Odrzuć",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Specjalizacja",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Kompetencje",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"Nie podano opisu.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Informacje",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Wyczyść porównywarkę",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"Porównanie partnerów",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Rola",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Koncentracja na technologii",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Opis",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Wybór języka",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Wyloguj",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Partner promujący integrację",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "O Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Skontaktuj się z nami",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Kariera",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Poznaj naszych partnerów",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Opinia",
    [KEYS.L18N_KEY_LABEL_HELP]: "Pomoc",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Warunki korzystania",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: 'Oświadczenie o ochronie prywatności',
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Znaki towarowe",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Przejrzystość łańcucha dostaw",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mapa witryny",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "O Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Skontaktuj się z nami",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Kariera",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Poznaj naszych partnerów",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Opinia",
    [KEYS.L18N_KEY_LABEL_HELP]: "Pomoc",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Warunki korzystania",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Oświadczenie o ochronie prywatności",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Znaki towarowe",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Przejrzystość łańcucha dostaw",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Mapa witryny",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Jak kupować",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Partnerzy",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Produkty i usługi",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Rozwiązania",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Wsparcie",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Naucz się",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Poznaj Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Menu",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Zamknij",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Zobacz więcej",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Zobacz mniej",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Nie masz konta?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "zarejestruj się"
  }
});

export default plPLTranslations;
